// Task Cards — People, Portraiture & Special Genres
export const GENRES = [
  {
    id: "indoor-natural-light",
    photo: "/taskcards/indoor-natural-light.jpg",
    icon: "House",
    title: { en: "Indoor Natural Light", es: "Luz Natural en Interior" },
    tagline: { en: "Turn a window into a free, beautiful softbox.", es: "Convierte una ventana en un softbox gratis y hermoso." },
    settings: [
      { k: "aperture", v: "f/2–f/2.8" },
      { k: "iso", v: "400–1600" },
      { k: "wb", v: "Auto / Cloudy" },
    ],
    tips: {
      en: [
        "Place your subject beside (not facing) a large window.",
        "Turn them toward the light for soft, even illumination.",
        "Use a white wall or foam board opposite the window to fill shadows.",
        "Sheer curtains diffuse harsh direct sun into gorgeous soft light.",
      ],
      es: [
        "Coloca a tu sujeto junto a (no frente a) una ventana grande.",
        "Giralo hacia la luz para una iluminacion suave y pareja.",
        "Usa una pared blanca o un carton opuesto a la ventana para rellenar sombras.",
        "Cortinas finas difunden el sol directo en una luz suave preciosa.",
      ],
    },
    remember: { en: "Subject beside the window, face toward the light.", es: "Sujeto junto a la ventana, cara hacia la luz." },
  },
  {
    id: "outdoor-natural-light",
    photo: "/taskcards/outdoor-natural-light.jpg",
    icon: "Sun",
    title: { en: "Outdoor Natural Light", es: "Luz Natural en Exterior" },
    tagline: { en: "Read the sun and find the flattering light anywhere.", es: "Lee el sol y encuentra la luz favorecedora en cualquier lugar." },
    settings: [
      { k: "aperture", v: "f/2.8–f/5.6" },
      { k: "iso", v: "100–400" },
      { k: "tip", v: "shoot open shade at noon" },
    ],
    tips: {
      en: [
        "Avoid harsh midday sun — move into open shade for soft light.",
        "Golden hour (just after sunrise / before sunset) is the warmest, softest.",
        "Backlight your subject and expose for the face for a glowing rim.",
        "Overcast skies are a giant softbox — perfect for portraits.",
      ],
      es: [
        "Evita el sol fuerte del mediodia — busca sombra abierta para luz suave.",
        "La hora dorada (tras el amanecer / antes del atardecer) es la mas calida y suave.",
        "Pon a tu sujeto a contraluz y expon para la cara para un borde luminoso.",
        "El cielo nublado es un softbox gigante — perfecto para retratos.",
      ],
    },
    remember: { en: "Shade or golden hour beats harsh noon sun.", es: "La sombra o la hora dorada superan al sol fuerte del mediodia." },
  },
  {
    id: "portrait-posing-female",
    photo: "/taskcards/portrait-posing-female.jpg",
    icon: "PersonSimple",
    title: { en: "Portrait Posing — Female", es: "Pose de Retrato — Mujer" },
    tagline: { en: "Flattering, natural poses that show grace and confidence.", es: "Poses favorecedoras y naturales que muestran gracia y confianza." },
    settings: [
      { k: "aperture", v: "f/1.8–f/2.8" },
      { k: "focal", v: "85–135mm" },
      { k: "focus", v: "Eye-AF / single point on eye" },
    ],
    tips: {
      en: [
        "Angle the body away from the camera, then turn the face back toward it.",
        "Create separation: keep arms slightly away from the torso.",
        "Shift weight to the back foot for a natural S-curve.",
        "Soft chin slightly forward and down to define the jawline.",
        "Give an action: walk, play with hair, look away then back.",
      ],
      es: [
        "Angula el cuerpo lejos de la camara y gira la cara de vuelta hacia ella.",
        "Crea separacion: manten los brazos ligeramente lejos del torso.",
        "Pasa el peso al pie de atras para una curva en S natural.",
        "Menton suave hacia adelante y abajo para definir la mandibula.",
        "Da una accion: caminar, jugar con el cabello, mirar lejos y volver.",
      ],
    },
    remember: { en: "Angle the body, turn the face, create space.", es: "Angula el cuerpo, gira la cara, crea espacio." },
  },
  {
    id: "portrait-posing-male",
    photo: "/taskcards/portrait-posing-male.jpg",
    icon: "PersonSimple",
    title: { en: "Portrait Posing — Male", es: "Pose de Retrato — Hombre" },
    tagline: { en: "Strong, grounded poses that read as confident, not stiff.", es: "Poses firmes y solidas que se ven seguras, no rigidas." },
    settings: [
      { k: "aperture", v: "f/2–f/4" },
      { k: "focal", v: "50–135mm" },
      { k: "focus", v: "Eye-AF / single point on eye" },
    ],
    tips: {
      en: [
        "Square the shoulders more for a broad, powerful look.",
        "Give the hands a job: in pockets (thumbs out), crossed arms, or on a wall.",
        "A slight lean toward the camera adds presence.",
        "Keep the jaw forward and down to avoid a double chin.",
        "Relaxed, natural expressions beat forced smiles — get them talking.",
      ],
      es: [
        "Cuadra mas los hombros para un aspecto amplio y poderoso.",
        "Dale tarea a las manos: en los bolsillos (pulgares fuera), brazos cruzados o en una pared.",
        "Una ligera inclinacion hacia la camara anade presencia.",
        "Manten la mandibula adelante y abajo para evitar papada.",
        "Expresiones relajadas y naturales superan a las sonrisas forzadas — hazlo hablar.",
      ],
    },
    remember: { en: "Square shoulders, busy hands, relaxed jaw.", es: "Hombros cuadrados, manos ocupadas, mandibula relajada." },
  },
  {
    id: "portrait-posing-group",
    photo: "/taskcards/portrait-posing-group.jpg",
    icon: "UsersThree",
    title: { en: "Portrait Posing — Group", es: "Pose de Retrato — Grupo" },
    tagline: { en: "Keep everyone sharp, connected, and flatteringly arranged.", es: "Manten a todos nitidos, conectados y bien colocados." },
    settings: [
      { k: "aperture", v: "f/5.6–f/8 (depth)" },
      { k: "iso", v: "200–800" },
      { k: "focus", v: "focus on the front row" },
    ],
    tips: {
      en: [
        "Stop down to f/5.6–f/8 so every face stays in focus.",
        "Stagger heights — avoid a flat line; use triangles and levels.",
        "Bring people physically close; gaps look awkward.",
        "Put taller people behind and toward the center.",
        "Shoot a burst — someone always blinks.",
      ],
      es: [
        "Cierra a f/5.6–f/8 para que cada cara quede enfocada.",
        "Escalona las alturas — evita la linea plana; usa triangulos y niveles.",
        "Acerca a las personas fisicamente; los huecos se ven raros.",
        "Pon a los mas altos detras y hacia el centro.",
        "Dispara una rafaga — alguien siempre parpadea.",
      ],
    },
    remember: { en: "f/8, stagger heights, close the gaps, shoot a burst.", es: "f/8, escalona alturas, cierra huecos, dispara rafaga." },
  },
  {
    id: "landscape",
    photo: "/taskcards/landscape.jpg",
    icon: "Mountains",
    title: { en: "Landscape Photography", es: "Fotografia de Paisaje" },
    tagline: { en: "Sharp, deep, dramatic scenes from foreground to horizon.", es: "Escenas nitidas, profundas y dramaticas del primer plano al horizonte." },
    settings: [
      { k: "aperture", v: "f/8–f/11" },
      { k: "iso", v: "100" },
      { k: "focus", v: "~1/3 into the scene" },
    ],
    tips: {
      en: [
        "Use a tripod and low ISO for maximum detail.",
        "Add a strong foreground element to create depth.",
        "Shoot at golden hour or blue hour for the best light.",
        "Keep the horizon level and off-center (rule of thirds).",
        "A polarizer deepens skies and cuts glare on water and leaves.",
      ],
      es: [
        "Usa tripode e ISO bajo para el maximo detalle.",
        "Anade un primer plano fuerte para crear profundidad.",
        "Dispara en hora dorada o azul para la mejor luz.",
        "Manten el horizonte nivelado y descentrado (regla de tercios).",
        "Un polarizador intensifica cielos y reduce reflejos en agua y hojas.",
      ],
    },
    remember: { en: "Tripod, f/11, ISO 100, golden light.", es: "Tripode, f/11, ISO 100, luz dorada." },
  },
  {
    id: "macro",
    photo: "/taskcards/macro.jpg",
    icon: "Flower",
    title: { en: "Macro Photography", es: "Fotografia Macro" },
    tagline: { en: "Reveal a tiny world with extreme close-up detail.", es: "Revela un mundo diminuto con detalle de primerisimo plano." },
    settings: [
      { k: "aperture", v: "f/8–f/16 (more depth)" },
      { k: "shutter", v: "fast / tripod" },
      { k: "focus", v: "Manual focus" },
    ],
    tips: {
      en: [
        "Depth of field is razor-thin up close — stop down to f/11–f/16.",
        "Manual focus, then rock gently back and forth to nail it.",
        "Use a tripod; even tiny movements ruin sharpness at this scale.",
        "Diffused light (cloud, softbox) avoids harsh shadows on small subjects.",
        "Focus stacking blends many shots for front-to-back sharpness.",
      ],
      es: [
        "La profundidad de campo es finisima de cerca — cierra a f/11–f/16.",
        "Enfoque manual, luego mecete suavemente hacia adelante y atras para clavarlo.",
        "Usa tripode; movimientos diminutos arruinan la nitidez a esta escala.",
        "La luz difusa (nube, softbox) evita sombras duras en sujetos pequenos.",
        "El apilado de enfoque combina varias tomas para nitidez total.",
      ],
    },
    remember: { en: "Stop down, manual focus, tripod, diffuse light.", es: "Cierra el diafragma, enfoque manual, tripode, luz difusa." },
  },
  {
    id: "night-photography",
    photo: "/taskcards/night-photography.jpg",
    icon: "Moon",
    title: { en: "Night Photography", es: "Fotografia Nocturna" },
    tagline: { en: "Capture cities, stars and moods after dark.", es: "Captura ciudades, estrellas y atmosferas tras el anochecer." },
    settings: [
      { k: "aperture", v: "f/2.8–f/8" },
      { k: "shutter", v: "1s–30s (tripod)" },
      { k: "iso", v: "800–3200" },
    ],
    tips: {
      en: [
        "Use a tripod and a 2-second timer (or remote) to avoid shake.",
        "Shoot RAW to control noise and white balance afterward.",
        "Manual focus on a bright distant light, or use live-view magnification.",
        "Cityscapes: low ISO + long exposure for clean light trails.",
        "Include a lit foreground to anchor the scene.",
      ],
      es: [
        "Usa tripode y temporizador de 2 segundos (o remoto) para evitar trepidacion.",
        "Dispara RAW para controlar el ruido y el balance de blancos despues.",
        "Enfoque manual sobre una luz lejana brillante, o usa la lupa del live view.",
        "Paisajes urbanos: ISO bajo + exposicion larga para estelas limpias.",
        "Incluye un primer plano iluminado para anclar la escena.",
      ],
    },
    remember: { en: "Tripod + long exposure + RAW = clean night shots.", es: "Tripode + exposicion larga + RAW = tomas nocturnas limpias." },
  },
  {
    id: "street",
    photo: "/taskcards/street.jpg",
    icon: "PersonSimple",
    title: { en: "Street Photography", es: "Fotografia Callejera" },
    tagline: { en: "Catch candid, fleeting moments of everyday life.", es: "Captura momentos espontaneos y fugaces de la vida diaria." },
    settings: [
      { k: "aperture", v: "f/8 (zone focus)" },
      { k: "shutter", v: "1/250s+" },
      { k: "iso", v: "Auto (cap 3200)" },
    ],
    tips: {
      en: [
        "Pre-set f/8 and zone-focus so you're always ready to shoot fast.",
        "Use a small, quiet camera and a 35mm or 50mm lens to blend in.",
        "Wait at good light/background, then let the subject walk into the frame.",
        "Shoot from the hip or eye level — be respectful and discreet.",
        "Tell a story: capture gesture, interaction, and context.",
      ],
      es: [
        "Preajusta f/8 y enfoca por zona para estar siempre listo a disparar rapido.",
        "Usa una camara pequena y silenciosa con un 35mm o 50mm para pasar desapercibido.",
        "Espera en buena luz/fondo y deja que el sujeto entre al encuadre.",
        "Dispara desde la cadera o a la altura de los ojos — con respeto y discrecion.",
        "Cuenta una historia: capta gesto, interaccion y contexto.",
      ],
    },
    remember: { en: "f/8 and be there. Anticipate the moment.", es: "f/8 y estar ahi. Anticipa el momento." },
  },
  {
    id: "sports-action",
    photo: "/taskcards/sports-action.jpg",
    icon: "Timer",
    title: { en: "Sports & Action", es: "Deportes y Accion" },
    tagline: { en: "Freeze fast motion at the peak of the moment.", es: "Congela el movimiento rapido en el punto culminante." },
    settings: [
      { k: "shutter", v: "1/1000s+" },
      { k: "focus", v: "AF-C + tracking" },
      { k: "drive", v: "Continuous burst" },
    ],
    tips: {
      en: [
        "Use 1/1000s or faster to freeze athletes; 1/2000s for fast sports.",
        "Set AF-C (continuous) with subject tracking and back-button focus.",
        "Shoot bursts and time the peak action (the jump, the kick).",
        "Pre-focus on where the action will happen, then track.",
        "A bright lens (f/2.8) keeps shutter fast in dim arenas.",
      ],
      es: [
        "Usa 1/1000s o mas para congelar atletas; 1/2000s para deportes rapidos.",
        "Configura AF-C (continuo) con seguimiento de sujeto y enfoque al boton trasero.",
        "Dispara rafagas y cronometra el punto maximo (el salto, la patada).",
        "Pre-enfoca donde ocurrira la accion y luego sigue.",
        "Un lente luminoso (f/2.8) mantiene la velocidad alta en pabellones oscuros.",
      ],
    },
    remember: { en: "Fast shutter, AF-C, burst, anticipate the peak.", es: "Velocidad alta, AF-C, rafaga, anticipa el climax." },
  },
  {
    id: "astrophotography",
    photo: "/taskcards/astrophotography.jpg",
    icon: "Star",
    title: { en: "Astrophotography (Milky Way)", es: "Astrofotografia (Via Lactea)" },
    tagline: { en: "Capture stars and the galaxy from a dark sky.", es: "Captura estrellas y la galaxia desde un cielo oscuro." },
    settings: [
      { k: "aperture", v: "f/2.8 (widest)" },
      { k: "shutter", v: "15–25s" },
      { k: "iso", v: "1600–6400" },
    ],
    tips: {
      en: [
        "Get far from city light pollution; a new moon and clear sky are ideal.",
        "Use the '500 rule': max shutter ≈ 500 / focal length, before stars trail.",
        "Manual focus to infinity on a bright star using live-view zoom.",
        "Sturdy tripod, 2s timer, and shoot RAW.",
        "A wide, fast lens (14–24mm f/2.8) gathers the most sky and light.",
      ],
      es: [
        "Alejate de la contaminacion luminica; luna nueva y cielo despejado son ideales.",
        "Usa la 'regla de 500': velocidad max ≈ 500 / distancia focal, antes de que las estrellas se muevan.",
        "Enfoque manual al infinito sobre una estrella brillante usando la lupa del live view.",
        "Tripode firme, temporizador de 2s y dispara RAW.",
        "Un lente angular y luminoso (14–24mm f/2.8) capta mas cielo y luz.",
      ],
    },
    remember: { en: "Dark sky, f/2.8, 20s, high ISO, infinity focus.", es: "Cielo oscuro, f/2.8, 20s, ISO alto, enfoque al infinito." },
  },
  {
    id: "pets",
    photo: "/taskcards/pets.jpg",
    icon: "PawPrint",
    title: { en: "Pet Photography", es: "Fotografia de Mascotas" },
    tagline: { en: "Sharp, characterful shots of animals on the move.", es: "Tomas nitidas y con caracter de animales en movimiento." },
    settings: [
      { k: "aperture", v: "f/2.8–f/4" },
      { k: "shutter", v: "1/500s+" },
      { k: "focus", v: "AF-C + Animal Eye-AF" },
    ],
    tips: {
      en: [
        "Get down to the animal's eye level for a connected, engaging shot.",
        "Focus on the eyes; use Animal Eye-AF if your camera has it.",
        "Fast shutter (1/500s+) freezes zoomies and tail wags.",
        "Use treats or a squeaky toy to grab attention and perky ears.",
        "Natural window or outdoor light flatters fur best.",
      ],
      es: [
        "Ponte a la altura de los ojos del animal para una toma conectada y cautivadora.",
        "Enfoca los ojos; usa el Eye-AF de animales si tu camara lo tiene.",
        "Velocidad alta (1/500s+) congela las carreras y los coletazos.",
        "Usa premios o un juguete chillon para captar la atencion y orejas atentas.",
        "La luz natural de ventana o exterior favorece mejor el pelaje.",
      ],
    },
    remember: { en: "Eye level, eye focus, fast shutter, get their attention.", es: "A su altura, enfoca el ojo, velocidad alta, capta su atencion." },
  },
  {
    id: "event-wedding",
    photo: "/taskcards/event-wedding.jpg",
    icon: "Confetti",
    title: { en: "Events & Weddings", es: "Eventos y Bodas" },
    tagline: { en: "Capture once-in-a-lifetime moments in mixed, fast-changing light.", es: "Captura momentos irrepetibles en luz mixta y cambiante." },
    settings: [
      { k: "aperture", v: "f/2–f/2.8" },
      { k: "iso", v: "Auto (cap 6400)" },
      { k: "drive", v: "Single shots + key bursts" },
    ],
    tips: {
      en: [
        "Use a fast lens (f/2.8 or brighter) for dim receptions.",
        "Bounce flash off ceilings for natural-looking indoor light.",
        "Use dual card slots to back up every shot in real time.",
        "Anticipate moments: the kiss, the toss, the tears — be ready early.",
        "Shoot RAW; reception lighting is a white-balance nightmare.",
      ],
      es: [
        "Usa un lente luminoso (f/2.8 o mas) para recepciones oscuras.",
        "Rebota el flash en techos para una luz interior de aspecto natural.",
        "Usa ranuras dobles para respaldar cada toma en tiempo real.",
        "Anticipa momentos: el beso, el lanzamiento, las lagrimas — esta listo antes.",
        "Dispara RAW; la luz de recepcion es una pesadilla de balance de blancos.",
      ],
    },
    remember: { en: "Fast lens, bounce flash, backup cards, anticipate.", es: "Lente luminoso, flash rebotado, tarjetas de respaldo, anticipa." },
  },
  {
    id: "black-and-white",
    photo: "/taskcards/black-and-white.jpg",
    icon: "Palette",
    title: { en: "Black & White", es: "Blanco y Negro" },
    tagline: { en: "Strip away color to reveal light, shape and emotion.", es: "Quita el color para revelar luz, forma y emocion." },
    tips: {
      en: [
        "Look for contrast, texture and strong shapes — they carry B&W.",
        "Shoot RAW (with a monochrome preview) so you keep color data to convert.",
        "Side light and dramatic shadows shine without color distraction.",
        "Push contrast and dodge/burn in editing to direct the eye.",
        "Great for high-contrast scenes, portraits, and moody weather.",
      ],
      es: [
        "Busca contraste, textura y formas fuertes — son lo que sostiene el B&N.",
        "Dispara RAW (con previsualizacion monocromatica) para conservar el color y convertir.",
        "La luz lateral y las sombras dramaticas brillan sin la distraccion del color.",
        "Sube el contraste y aclara/oscurece en la edicion para dirigir la mirada.",
        "Ideal para escenas de alto contraste, retratos y clima atmosferico.",
      ],
    },
    remember: { en: "Contrast, texture, shape — that's what B&W lives on.", es: "Contraste, textura, forma — de eso vive el B&N." },
  },
];
